import styled from 'astroturf/react'
import { useSelector } from 'react-redux'
import { EventLocation } from '@calendly/booking-kit'
import { Loader } from '@calendly/ui/components/loader'

import PaymentSummary from 'components/payment/summary'
import { timeNotationSelector, eventSelector } from 'selectors'
import { chargeSelector } from 'selectors/payment'
import { useInvitee } from 'components/use_invitee'
import ErrorAlert from 'components/error/alert'

import Details from './details'
import Marker from './details/marker'
import PublisherName from './details/publisher'
import EventTime from './details/event_time'
import Timezone from './details/timezone'
import Attendees from './details/attendees'
import _Payment from "confirmation_details-Payment.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/confirmation_details.js?styleId=Payment";


const Payment = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Payment",
  styles: _Payment
})

export const ConfirmationDetails = () => {
  const event = useSelector(eventSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const invitee = useInvitee()
  const charge = useSelector(chargeSelector)

  if (event === undefined || invitee === undefined) return <Loader />

  if (event === null || invitee === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    name, guests, scheduled_profile: scheduledProfile
  } = event

  const { timezone, email } = invitee

  return (
    <div>
      <Details>
        <Marker text={name} />
        <PublisherName name={scheduledProfile.name} />
        <EventTime
          source={event}
          timezone={timezone}
          timeNotation={timeNotation}
        />
        <Timezone value={timezone} />
        <EventLocation event={event} />
        <Attendees items={[email, ...guests]} />
      </Details>
      <Payment charge={charge} />
    </div>
  )
}
